import { Box, Button, Typography } from '@mui/material';
import React from 'react';

import { SEVERITY_CONFIG } from '../constants';
import { type SeverityLevel } from '../types';

interface SeveritySelectorProps {
  value: SeverityLevel;
  onChange: (level: SeverityLevel) => void;
  disabled?: boolean;
}

export const SeveritySelector: React.FC<SeveritySelectorProps> = ({ value, onChange, disabled }) => {
  return (
    <Box>
      <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.75 }}>
        Severity
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 0.75 }}>
        {(Object.keys(SEVERITY_CONFIG) as SeverityLevel[]).map((level) => {
          const cfg = SEVERITY_CONFIG[level];
          const isSelected = value === level;
          return (
            <Button
              key={level}
              type="button"
              variant="outlined"
              size="small"
              onClick={() => onChange(level)}
              disabled={disabled}
              sx={{
                py: 0.5,
                px: 0.5,
                fontSize: '0.75rem',
                fontWeight: 500,
                textTransform: 'none',
                borderRadius: '8px',
                minWidth: 0,
                backgroundColor: isSelected ? cfg.activeBg : '#ffffff',
                color: isSelected ? cfg.activeText : '#4b5563',
                borderColor: isSelected ? cfg.activeBorder : '#e5e7eb',
                '&:hover': {
                  backgroundColor: isSelected ? cfg.activeBg : '#f9fafb',
                  borderColor: isSelected ? cfg.activeBorder : '#d1d5db',
                },
              }}
            >
              <Box
                component="span"
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: isSelected ? '#ffffff' : cfg.dotColor,
                  mr: 0.6,
                  flexShrink: 0,
                }}
              />
              {cfg.label}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};
